import React,{useContext} from "react";
import { ThemeUpdate } from "../provider/AppProvider";
interface FcFllowComponentPros{
    user:string;
}
export function FcFllowComponent(props: FcFllowComponentPros) {
    const changeTheme = useContext(ThemeUpdate);
    const showMessage = ()=>{
        alert(`fllow: ${props.user}`);
    }
    const handleClick = ()=>{
        changeTheme();
        setTimeout(showMessage,5000);
    }
    return <button onClick={handleClick}>Fc Fllow</button>
}